export default "__VITE_ASSET__BC8ienR7__"